<template>
    <a class="btn visually-hidden" id="btnLandingPageCollapse" data-bs-toggle="collapse" href="#landing-page-comp" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">T</a>

    <div class="landing-page collapse show" id="landing-page-comp">
        <div class="landing-page__content-wrapper">
            <div class="landing-page__content">
                <div v-if="columnView == 'detail'">
                    <p>The data presented below represent the total participants enrolled in projects associated with the listed research, condition, or disease category. Research, condition, and disease categories are not mutually exclusive. All participants enrolled in a project's studies are included in all categories associated with that project. Individual research projects can be included in multiple categories so amounts depicted within each column of this table do not add up to the total participants enrolled in NIH-funded research.</p>
                    <p><u>Example:</u> R01 IC12345 enrolled 300 participants and is associated with the Basic Behavioral and Social Science and Prevention categories. All 300 participants will appear in both the Basic Behavioral and Social Science and Prevention category totals for that IC.</p>
                </div>
                <div v-else>
                    <p>This report displays the typical representation of participants in human subject studies enrolled in NIH clinical research projects associated with the listed research, condition, or disease category. Median percent participation is presented for each demographic variable.</p>

                    <p>Adjust the filters to view characteristics by race or ethnicity or to exclude single population studies. Drill down to explore more detailed statistics.</p>

                    <p><b>**Notes:</b> Research, condition, and disease categories are not mutually exclusive, so the same projects may appear in more than one category. All participants enrolled in a project's studies are included in all categories associated with that project. Individual research projects can be included in multiple categories so amounts depicted within each column of this table do not add up to the total participants enrolled in NIH-funded research.</p>

                    <p><u>Example:</u> R01 IC12345 enrolled 300 participants and is associated with the Basic Behavioral and Social Science and Prevention categories. All 300 participants will appear in both the Basic Behavioral and Social Science and Prevention category totals for that IC.</p>
                    <p>See the <a href="/reportweb/web/displayreport?rid=957">RCDC Inclusion Statistics Report (RISR) FAQs</a> for more details about these data. </p>
                    <p>Human Subjects System (HSS) Enrollments by Age Groups in Research, Condition, and Disease Categorization (RCDC) Categories are available in Excel format only on the <a href="/research/inclusion-women-and-minorities-clinical-research">NIH Report Inclusion of Women and Minorities in Clinical Research</a> page.</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
export default {
    name: 'LandingPage',
    computed: {
        ...mapGetters([
            'afterFilteringData',
            'columnView'
        ])
    },
    mounted () {
        var scrollTable = $('.table-comp__scroll'),
            prevLeft = 0,
            currentLeft = 0;

        if (scrollTable.length > 0) {
            scrollTable.scroll(() => {

                setTimeout(() => {
                    currentLeft = scrollTable.scrollLeft();
                    if (scrollTable.scrollTop() === 0) {
                        if (prevLeft === currentLeft) {
                            if (!this.afterFilteringData && $("#btnLandingPageCollapse").length > 0) {
                                $("#btnLandingPageCollapse")[0].click();
                            }
                        } else {
                            prevLeft = currentLeft;
                        }
                    } else {
                        if (!$('#landing-page-comp').hasClass('collapsing') && !$('#landing-page-comp').hasClass('collapse') && $("#btnLandingPageCollapse").length > 0) {
                            $("#btnLandingPageCollapse")[0].click();
                        }
                    }
                }, 1);
            });
        }

        $('#landing-page-comp').on('hide.bs.collapse', function () {
            window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'), true);
        });

        $('#landing-page-comp').on('hidden.bs.collapse', function () {
            window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'));
        });

        $('#landing-page-comp').on('shown.bs.collapse', function () {
            window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'));
        });

        $('body').on('wheel', function (e) {
            var target = $(e.target);

            
            if (target.closest('.landing-page__content, #dropdowns-top-filter, .floated-background, .floated-header').length > 0 && e.originalEvent.deltaY >= 0) {
                setTimeout(() => {
                    if ($("#btnLandingPageCollapse").length > 0) {
                        $("#btnLandingPageCollapse")[0].click();
                    }
                }, 1);
            }

            if (target.closest('#dropdowns-top-filter, .floated-background, .floated-header').length > 0) {
                if (e.originalEvent.deltaY < 0) {
                    setTimeout(() => {
                        if ($("#btnLandingPageCollapse").length > 0) {
                            $("#btnLandingPageCollapse")[0].click();
                        }
                    }, 1);
                }
            }
        });

        $(window).resize(function () {
            window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'));
        });

        function detectPhoneSwipes () {
            var swipe = document.getElementById('landing-page-comp'),
                touchstartY = 0,
                touchendY = 0;
                // swiped;

            function handleSwipe () {
                // swiped = 'swiped: ';
                if (touchendY < touchstartY) {
                    $('#landing-page-comp').toggle('hide');
                }
            }

            swipe.addEventListener('touchstart', function (event) {
                touchstartY = event.changedTouches[0].screenY;
            }, false);

            swipe.addEventListener('touchend', function (event) {
                touchendY = event.changedTouches[0].screenY;
                handleSwipe();
            }, false);
        };

        detectPhoneSwipes();
    }
};
</script>

<style lang="scss">
.landing-page {
    background-color: #fff;
    text-align: justify;

    &.collapsing {
        transition: height 0.7s ease;
    }
}

.landing-page__content-wrapper {
    padding: 10px $home-page-padding;
}

.landing-page__content {
    max-width: 700px;
    margin: 0 auto;

    p {
        margin-bottom: 0;
    }

    p + p {
        margin-top: 10px;
    }
}
</style>

